class ReadMore {
  constructor(el, opt) {
    this.el = el;
    this.options = opt;
    this.init();
    this.bind();
  }

  init() {
    this.trigger = this.el.querySelector(this.options.selectors.trigger);
    this.content = this.el.querySelector(this.options.selectors.content);
    this.contentHeight = this.content.offsetHeight + 'px';
    this.content.style.height = 0;
  }

  bind() {
    this.trigger.addEventListener('click', () => this.toggle());
    let resize = utilities.debounce(e => this.resize(e), 300);
    window.addEventListener('resize', resize);
  }

  toggle() {
    this.el.classList.contains('is-open') ? this.close() : this.open();
    this.el.classList.toggle('is-open');
  }

  open() {
    this.content.style.height = this.contentHeight;
    if ( this.trigger.textContent && this.trigger.nodeName == "BUTTON" )
      this.trigger.textContent = 'Less';
  }

  close() {
    this.content.style.height = 0;
    if ( this.trigger.textContent && this.trigger.nodeName == "BUTTON" )
      this.trigger.textContent = 'More';
  }

  resize(e) {
    this.contentHeight = this.getHeight(this.content) + 'px';
    if ( this.el.classList.contains('is-open') ) {
      this.content.style.height = this.contentHeight;
    }
  }

  getHeight(el) {
    let height = 0;
    for ( let i = 0; i < el.children.length; i++ ) {
      let child = el.children[i];
      let style = getComputedStyle(child);
      height += ( child.offsetHeight + parseInt(style.getPropertyValue('margin-top')) + parseInt(style.getPropertyValue('margin-bottom')) );
    }
    return height;
  }
}

export default ReadMore;



// WEBPACK FOOTER //
// ./scripts/components/readmore.js